import get from 'lodash/get'

export default {
  computed: {
    preparedScopes() {
      const { apiKeyScopes = 'roles' } = this // Because it scopes in Points and roles in CH

      return (get(this.apiKey, apiKeyScopes) || [])
        .reduce((acc, i) => {
          const v = i.split(':')
          const index = acc.findIndex(e => e.group === v[0])
          if (index !== -1) {
            acc[index].scopes.push(v[1])
          } else {
            acc.push({
              group: v[0],
              scopes: [v[1]],
            })
          }
          return acc
        }, [])
    },
  },
  methods: {
    flattenScopes() {
      const preparedScopes = []
      const { scopes, selectedScopes, selectedRoles } = this
      selectedScopes.forEach(s => {
        const index = scopes.findIndex(e => s === e.group)
        selectedRoles[index].forEach(r => preparedScopes.push(`${s}:${r}`))
      })
      return preparedScopes
    },
  },
}
